import React, { type FC } from 'react';

import { PageSegmentLoadStart } from '@confluence/browser-metrics/entry-points/PageSegmentLoadStart';
import { LoadableAfterPaint } from '@confluence/loadable';

import type { ObjectSidebarControlProps } from '../src/ObjectSidebarControl';
import { OBJECT_SIDEBAR_CONTROL_METRIC } from '../src/perf.config';

const ObjectSidebarControlLoader = LoadableAfterPaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-ObjectSidebarControl" */ '../src/ObjectSidebarControl'
			)
		).ObjectSidebarControl,
});

export const ObjectSidebarControl: FC<ObjectSidebarControlProps> = (props) => (
	<>
		<PageSegmentLoadStart metric={OBJECT_SIDEBAR_CONTROL_METRIC} />
		<ObjectSidebarControlLoader {...props} />
	</>
);
